module.exports = __webpack_public_path__ + "static/media/ScoreBoardBanner.2263930e.svg";